import { getGutterValueInPixels } from '../../../util/styles/gutters';
import { mainContentColumnMaxWidth, mainContentWithUnifiedSidebarColumnMaxWidth } from '../ContentMainColumn.types';
import type { ContentSidebarPosition } from '../ContentSidebarColumn.types';
import {
  contentSidebarLeftMaxWidth,
  contentSidebarRightMaxWidth,
  unifiedSidebarRightContentMaxWidth,
} from '../ContentSidebarColumn.types';

import { useAppLayoutContext, useAppLayoutGutterSize } from './useAppLayoutContext';
import { useContentContainerContext } from './useContentContainerContext';

const getContentMaxWidth = (
  gutterSize: number,
  removeContentPadding: boolean,
  unifiedSidebar: boolean,
  sidebarPosition?: ContentSidebarPosition
) => {
  const gutterInPixels = getGutterValueInPixels(gutterSize);
  const totalGutterColumns = removeContentPadding ? 1 : 3;

  const mainColumnMaxWidth = unifiedSidebar ? mainContentWithUnifiedSidebarColumnMaxWidth : mainContentColumnMaxWidth;
  const rightSidebarMaxWidth = unifiedSidebar ? unifiedSidebarRightContentMaxWidth : contentSidebarRightMaxWidth;
  const sidebarWidth = sidebarPosition === 'left' ? contentSidebarLeftMaxWidth : rightSidebarMaxWidth;

  return mainColumnMaxWidth + sidebarWidth + gutterInPixels * totalGutterColumns;
};

type UseContentMaxWidth = () => number | undefined;
export const useContentMaxWidth: UseContentMaxWidth = () => {
  const { sidebarPosition, shouldFillAvailableSpace } = useContentContainerContext();
  const gutterSize = useAppLayoutGutterSize();
  const appLayoutContext = useAppLayoutContext();
  const removeContentPadding = appLayoutContext?.removeContentPadding ?? false;
  const unifiedSidebar = appLayoutContext?.unifiedSidebar ?? false;

  if (shouldFillAvailableSpace) {
    return undefined;
  }

  return getContentMaxWidth(gutterSize, removeContentPadding, unifiedSidebar, sidebarPosition);
};
